(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wpk-inquiry-form"]) return;
  try {
    
const itemField = document.querySelector('[data-wpk-item-field]');
if (itemField && !itemField.value) {
  const reference = new URLSearchParams(window.location.search).get('item');
  if (reference) itemField.value = reference.slice(0, 500);
}

  } catch(e) { console.error(e); }
})();
})();
